module.exports = __webpack_public_path__ + "static/img/mask.82ba766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask.png
// module id = mRby
// module chunks = 0